import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assessmentmaster',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.scss'],
  providers:[MasterService]
})
export class AssessmentComponent implements OnInit {

  memberdetails:any[]=[];
  classdetails:any[]=[];
  arrashead:any=[];
  arrastype:any=[];
  closeResult: string;
  classes: any=[];
  section: any=[];
  arrcourse:any=[];
  arrsubcomb:any=[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  objass:any={};
  objastype:any={};
  objfilt:any={};
  arreval:any=[];
  arrevpatern:any=[];
  arrcat:any=[{name:'Board'},{name:'Competitive'}];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  ngOnInit(): void {
    
    this.masasshead();
    this.masasstype();
    //this.massection();
  }


  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.objfilt.clid=resultArray[0].clid;
            this.getcourses();
        },
        error => console.log("Error :: " + error)
        )
  }

  private getcourses() {

    this.mservice.getcourse()
  .subscribe((result:any) => {
  
  this.arrcourse=result;
  this.objfilt.crid=result[0].crid;
  this.Getsubcomb();
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }

  Getsubcomb()
  {
    debugger
    this.mservice.sel_sp_exmsubcomb()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.objfilt.sucbid=resultArray[0].sucbid;
      //this.clsdate=resultArray;
      this.arrsubcomb = resultArray;
    //  this.getevpattern();
      },
     error => console.log("Error :: " + error)
  )
  }
   

  evalfilters()
  {
    this.masclass();
    this.getcourses();
    this.Getsubcomb();
  }
  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.section = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  masasshead() {
    this.mservice.sel_sp_masasshead()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrashead = resultArray;
            this.objfilt.asid=resultArray[0].asid;
           // this.fmodel.assid=resultArray[0].asid;
           this.masasstype();
        },
        error => console.log("Error :: " + error)
        )
  }
  masasstype() {
    this.mservice.sel_sp_masasstype()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrastype = resultArray;
            this.objfilt.astpid=resultArray[0].astpid;
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

 


  
  openasses(content,objdata,cmd) {
    debugger
    if(cmd=='insert')
    {
      this.objass={};
     
      
      
      this.objass.asid=0;
      this.objass.ascd='';
      this.objass.asnm='';
      this.objass.ascat='Board';
      // this.objsubcat.subcacd='';
      //this.objsubcat.subcanm='';
      this.objass.oprtag='insert';
     
    }
  
    else if(cmd=='update')
    {
      this.objass=objdata;
      this.objass.oprtag='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  saveassesmenthead()
{
//console.log('saveobj',this.objsubcat);
  this.mservice.save_sp_masasshead(this.objass)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.masasshead();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}


openastype(content,objdata,cmd) {
  debugger
  if(cmd=='insert')
  {
    this.objastype={};
   
    
    
    this.objastype.astpid=0;
    this.objastype.astpcd='';
    this.objastype.astpnm='';
    //this.objass.ascat='Board';
    // this.objsubcat.subcacd='';
    //this.objsubcat.subcanm='';
    this.objastype.oprtag='insert';
   
  }

  else if(cmd=='update')
  {
    this.objastype=objdata;
    this.objastype.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'md'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


saveastype()
{
console.log('saveobj',this.objastype);
  this.mservice.save_sp_masasstype(this.objastype)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.masasstype();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}
}
